import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { UIRouterModule } from '@uirouter/angular';
import { EntityDataService } from '@ngrx/data';
import { entityName, DeferBillingDataService } from '../data-services/defer-billing';
import { DeferBillingRoute } from './defer-billing.route';



@NgModule({
  // declarations: [],
  providers: [DeferBillingDataService],
  imports: [
    CommonModule,
    SharedModule,
    UIRouterModule.forChild({
      states: [DeferBillingRoute]
    })
  ]
})
export class DeferBillingModule {
    constructor(
        entityDataService: EntityDataService,
        deferBillingService: DeferBillingDataService
      ) {
        entityDataService.registerService(entityName, deferBillingService);
      }
}
